export const BREAKPOINT = 640;

export const THEME = {
  topDark: "#190013",
  topPurple: "#240419",
  topCircle: "#3c0f23",
  body: "#cfa076",
  bottom: "#d7ad7d",
  theme: "#a61a1d",
  personnel: "#a01828",
};

export const FONT_COLOR = {
  date: "#e46a4a",
  place: "#d04232",
  theme: "#a61a1d",
  personnel: "#a01828",
  shadow: "#926d53",
};
